import classnames from 'classnames';

import {TypographySize, useTypography} from '../../../hooks/typography';
import {NotificationOutline} from '../../../icons/notification-outline';

import styles from './styles.module.css';

export enum NotificationType {
    Info = 'info',
    Danger = 'danger',
    Warning = 'warning',
}

export type Props = {
    title: string;
    content: string | React.ReactNode;
    type?: NotificationType;
};

export const Notification = ({title, content, type = NotificationType.Info}: Props) => {
    const titleTypo = useTypography({
        size: TypographySize.BodyXLTrue,
    });

    const contentTypo = useTypography({
        size: TypographySize.BodyL,
    });

    return (
        <div className={classnames(styles.notification, styles[type])}>
            <NotificationOutline className={classnames(styles.icon, styles[type])} width={20} height={20} />
            <div className={classnames(styles.main)}>
                <div className={classnames(titleTypo)}>{title}</div>
                <div className={classnames(contentTypo)}>{content}</div>
            </div>
        </div>
    );
};
